import DownloadStatementArchive from "components/DownloadStatementArchive/DownloadStatementArchive";
import AuthPage from "components/shared/AuthPage";

const Dashboard = () => {
    return (
        <AuthPage userAuthenticated={true}>
            <DownloadStatementArchive />
        </AuthPage>
    );
};

export default Dashboard;
